<template>
    <BCard v-if="discount">
      <ValidationObserver ref="form" #default="{invalid}">
          <BForm @submit.prevent="onSubmit">
              <BRow>
                <TextInputValidated vsName="Name" :vsModel.sync="discount.name" vsMd="6" vsRequired vsRules="required" />
                <VSelectValidated vsName="Discount type" :vsOptions="discountTypes" :vsReduce="discount => discount.value" vsLabel="name" :vsModel.sync="discount.type" vsMd="6" vsRequired vsRules="required" />
                <VSelectValidated vsName="Apply discount to" @vsOnInput="onSelectedItemType" :vsReduce="itemType => itemType.value" :vsOptions="discountItemTypes" vsLabel="name" :vsModel.sync="discount.item_type" vsMd="6" vsRequired vsRules="required" />
                <VSelectValidated :vsName="itemLabel" :vsOptions="items" vsLabel="name" :vsReduce="item=>item.id" :vsModel.sync="discount.item_id" vsMd="6" v-if="items" />
                <DatepickerValidated vsName="Start date" :vsModel.sync="discount.start_date" vsMd="6" vsRequired vsRules="required" />
                <DatepickerValidated vsName="End date" :vsModel.sync="discount.end_date" vsMd="6" />
                <NumberInputValidated vsName="Value" :vsModel.sync="discount.value" vsMd="6" vsRequired vsRules="required" />
              </BRow>

              <!-- Action Buttons -->
              <BButton variant="primary" class="mt-4 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
              <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'discounts' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
          </BForm>
      </ValidationObserver>
  </BCard>
</template>

<script>
import { BCard, BRow, BForm, BButton } from 'bootstrap-vue';
import { onUnmounted, ref } from '@vue/composition-api';
import { ValidationObserver } from 'vee-validate';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import VSelectValidated from '@/components/forms/vSelectValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import discountModule from '../discountModule';
import popups from '@/hooks/popups';
import router from '@/router';
import store from '@/store';
import axios from '@axios';

export default {
    components: { BCard, BRow, BForm, BButton, ValidationObserver, TextInputValidated, NumberInputValidated, VSelectValidated, DatepickerValidated, CheckboxValidated },
    setup() {
        const { errorToast } = popups()
        const DISCOUNT_MODULE = 'discounts'
        const items = ref(null)
        const itemLabel = ref("Selecciona un elemento")
        const discount = ref(null)

        const discountTypes = [
            { name: 'Porcentaje', value: 'percentage' },
            { name: 'Importe', value: 'amount' }
        ]

        const discountItemTypes = [
            { name: 'Todos', value: 'all' },
            { name: 'Cursos', value: 'courses' },
            { name: 'Productos', value: 'products' },
            { name: 'Curso', value: 'course' },
            { name: 'Producto', value: 'product' },
            { name: 'Sección', value: 'section' },
            { name: 'Familia', value: 'family' }
        ]

        const onSubmit = function(){
          this.$refs.form.validate().then(success => {
              if(success) {
                  store.dispatch('discounts/updateDiscount', JSON.parse(JSON.stringify(discount.value)))
                      .then(response => { this.$router.push({ name: 'discounts' }) })
                      .catch(error => { errorToast('Can\'t add discount') })
              }
          })
        }

        /**
         * Cargar datos en función del la opción seleccionada
         */
         const onSelectedItemType = function(event, firstCall){


            if (!firstCall) {
                discount.value.item_id = null
            }

            if(event == "course"){
                itemLabel.value = "Select a course"
                axios.get('courses').then(response => {
                    items.value = response.data.courses
                })
                return
            }
            if(event == "product"){
                itemLabel.value = "Select a product"
                axios.get('products').then(response => {
                    items.value = response.data.products
                })
                return
            }
            if(event == "section"){
                itemLabel.value = "Select a course section"
                axios.get('sections').then(response => {
                    items.value = response.data.sections
                })
                return
            }
            if(event == "family"){
                itemLabel.value = "Select a product family"
                axios.get('families').then(response => {
                    items.value = response.data.families
                })
                return
            }
            items.value = null
        }


        if(!store.hasModule(DISCOUNT_MODULE)) store.registerModule(DISCOUNT_MODULE, discountModule)

        onUnmounted(() => {
            if(store.hasModule(DISCOUNT_MODULE)) store.unregisterModule(DISCOUNT_MODULE)
        })

        store.dispatch('discounts/fetchDiscount', { id: router.currentRoute.params.id }).then(response => {
            discount.value = response.data.discount
            onSelectedItemType(discount.value.item_type, true)
        })

        return {
            onSelectedItemType,
            discountItemTypes,
            discountTypes,
            itemLabel,
            onSubmit,
            discount,
            items
        }
    }
}
</script>
